import styled from 'styled-components'

export const KlarnaContainer = styled.div`
  klarna-placement {
    &::part(osm-message) {
      margin-top: 1rem;
      padding: 0;
    }
  }
`
